import { useState, useEffect } from 'react';

let counter = 0;

export const useId = (prefix, preferredId) => {
    const [id, setId] = useState(`${prefix}-${counter}`);
    counter += 1;

    useEffect(() => {
        if (preferredId) {
            setId(preferredId);
        }
    }, [preferredId]);

    return [id, setId];
};
